export enum OdometerPhotoType {
  Start = 'Start',
  End = 'End'
}
export enum UploadStatus {
  Pending = 'Pending',
  Uploaded = 'Uploaded',
  Failed = 'Failed'
}

export class OdometerReadingMedia {
  RecordId?: number;
  OdometerReadingRecordId: number;
  Value: string;
  FileFormat: string;
  PhotoType: OdometerPhotoType;
  UploadStatus?: UploadStatus;
  CreatedDate?: string;
  BlobFileName?: string;

  constructor(obj?: Partial<OdometerReadingMedia>) {
    if (obj) {
      Object.assign(this, obj);
    }
    else {
      throw Error('Object cannot be null');
    }
  }
}
